import React from 'react';
import { useSelector } from "react-redux"
import { SectionNotAllowed } from "../../../components"
import { CONTENT_DETAIL_SYSTEM } from "../../../constants"

const ContentVisibilityFilter = ({children, data}) => {
  const { isLoggedIn } = useSelector(state => state.account)

  const isAllowed_A = data.is_all_public ? true : isLoggedIn ? true : false
  const isAllowed_B = data.is_private ? (isLoggedIn ? true : false) : true
  const isAllowed = CONTENT_DETAIL_SYSTEM === 'A' ? isAllowed_A : isAllowed_B

  return isAllowed ? children : <SectionNotAllowed />
}

export default ContentVisibilityFilter
